/**
 * The `unit` vocabulary from API.md mapped onto the reserved status palette.
 *
 * Status colour never carries meaning alone: every consumer of this map renders
 * the `label` as text and the `shape` as a distinct glyph, so the red/green pair
 * stays separable under deuteranopia and in forced-colors mode.
 */
export const UNIT_STATES = {
  active: { tone: 'good', label: 'Active', shape: 'disc' },
  activating: { tone: 'warning', label: 'Activating', shape: 'ring' },
  failed: { tone: 'critical', label: 'Failed', shape: 'diamond' },
  inactive: { tone: 'neutral', label: 'Inactive', shape: 'bar' },
  unknown: { tone: 'neutral', label: 'Unknown', shape: 'hollow' },
};

export function unitState(unit) {
  return (
    UNIT_STATES[unit] || {
      tone: 'neutral',
      label: unit ? String(unit) : 'Unknown',
      shape: 'hollow',
    }
  );
}

/**
 * Meter severity. The fill carries the severity; the track is a lighter step of
 * the same hue (see styles.css), so state reads across the whole bar.
 */
export function usageTone(pct) {
  if (typeof pct !== 'number' || !Number.isFinite(pct)) return 'neutral';
  if (pct >= 90) return 'critical';
  if (pct >= 75) return 'warning';
  return 'nominal';
}

export const USAGE_TONE_LABEL = {
  nominal: 'within normal range',
  warning: 'high',
  critical: 'critical',
  neutral: 'unknown',
};
